export default {
  "newsCard": {
    "linkText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Read more"])}
  },
  "paginationInfo": {
    "pieceOne": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The posts"])},
    "pieceTwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["to"])},
    "pieceThree": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["of a total of"])},
    "pieceFour": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["are displayed."])}
  }
}